import type { ScreenSchema } from './types';

const flipCardsSchema: ScreenSchema = {
  template: 'flip-cards',
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    },
    flipcard: {
      iterate: 'cards',
      keyPrefix: 'flipcard',
      parts: [
        // Front label — omit from audio if back text is present (transcript use only)
        {
          field: 'heading',
          fallback: ['subheading'],
          omitIfPresent: ['no-title']
        },
        // Back text — the content revealed on flip
        { field: 'text' }
      ]
    }
  }
};

export default flipCardsSchema;
